import { render, staticRenderFns } from "./SideCategoreis.vue?vue&type=template&id=13ad80f3&scoped=true"
import script from "./SideCategoreis.vue?vue&type=script&lang=js"
export * from "./SideCategoreis.vue?vue&type=script&lang=js"
import style0 from "./SideCategoreis.vue?vue&type=style&index=0&id=13ad80f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad80f3",
  null
  
)

export default component.exports